import { render, staticRenderFns } from "./compactTopbar.vue?vue&type=template&id=6774232a&"
import script from "./compactTopbar.vue?vue&type=script&lang=js&"
export * from "./compactTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports